import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.10.1_sass@1.70.0_typescript@5.3.3_vite@5.0.12/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}